import { render } from "./img-loading.vue?vue&type=template&id=6a55e223&scoped=true&ts=true"
import script from "./img-loading.vue?vue&type=script&lang=ts"
export * from "./img-loading.vue?vue&type=script&lang=ts"

import "./img-loading.vue?vue&type=style&index=0&id=6a55e223&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a55e223"]])

export default __exports__